import { render } from "./McustomerGroupIndex.vue?vue&type=template&id=5bf85ae4&scoped=true"
import script from "./McustomerGroupIndex.vue?vue&type=script&lang=js"
export * from "./McustomerGroupIndex.vue?vue&type=script&lang=js"

import "./McustomerGroupIndex.vue?vue&type=style&index=0&id=5bf85ae4&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf85ae4"]])

export default __exports__